import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/registration/welcome-gyre.png'
import _imports_1 from '../assets/brand/gyre-icon-lg-bg-green.png'
import _imports_2 from '../assets/registration/email-icon.svg'
import _imports_3 from '../assets/registration/lock-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2bb1f688"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "login-page",
  "data-test": "login-page"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-page__welcome" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Welcome to Gyre",
    class: "welcome-image",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "login-footer" }, [
    /*#__PURE__*/_createElementVNode("ul", { class: "login-footer-list" }, [
      /*#__PURE__*/_createElementVNode("li", { class: "login-footer-item" }, [
        /*#__PURE__*/_createElementVNode("a", {
          "data-test": "about-link",
          href: "https://gyreteams.com",
          role: "link"
        }, "About")
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "login-footer-item" }, [
        /*#__PURE__*/_createElementVNode("a", {
          "data-test": "terms-link",
          href: "https://gyreteams.com/terms-of-service",
          role: "link"
        }, "Terms of Service")
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "login-footer-item" }, [
        /*#__PURE__*/_createElementVNode("a", {
          "data-test": "contact-link",
          href: "https://gyreteams.com/contact",
          role: "link"
        }, "Contact")
      ])
    ])
  ])
], -1))
const _hoisted_3 = { class: "login-page-right" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Gyre logo",
  class: "gyre-logo",
  src: _imports_1
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center brand-message" }, "We are now Gyre with a G.", -1))
const _hoisted_6 = { class: "login-form-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Login", -1))
const _hoisted_8 = { class: "login-label-section" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_10 = {
  key: 0,
  "data-test": "invalid-email-error",
  class: "error-message"
}
const _hoisted_11 = {
  key: 1,
  "data-test": "email-required-error",
  class: "error-message"
}
const _hoisted_12 = {
  key: 2,
  "data-test": "email-not-found-error",
  class: "error-message"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "placeholder-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Email icon",
    src: _imports_2
  })
], -1))
const _hoisted_14 = { class: "login-label-section" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1))
const _hoisted_16 = {
  key: 0,
  "data-test": "password-required-error",
  class: "error-message"
}
const _hoisted_17 = {
  key: 1,
  "data-test": "password-length-error",
  class: "error-message"
}
const _hoisted_18 = {
  key: 2,
  "data-test": "password-incorrect-error",
  class: "error-message"
}
const _hoisted_19 = {
  key: 3,
  "data-test": "locked-out-error",
  class: "error-message"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "placeholder-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "lock icon",
    src: _imports_3
  })
], -1))
const _hoisted_22 = { class: "checkboxes" }
const _hoisted_23 = { class: "checkbox-default" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "checkbox" }, "Keep me logged in", -1))
const _hoisted_25 = {
  key: 0,
  "data-test": "submit-error",
  class: "error-message"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "forgot-password" }, [
  /*#__PURE__*/_createElementVNode("a", {
    "data-test": "forgot-password-link",
    href: "/account/forgotpassword",
    role: "link"
  }, "Forgot your password?")
], -1))

import { computed, ref, onMounted } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { email, minLength, required } from "@vuelidate/validators";
import axios, { AxiosError } from "axios";
import { debug as d } from "debug";
import { useRouter } from "vue-router";
import { LoginApiModel } from "../api-models";
import SubmitButton from "../components/submit-button.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'login-page',
  setup(__props) {

const debug = d("cs.LoginPage");

const userEmail = ref("");
const password = ref("");
const attemptedToSubmit = ref(false);
const persistLogin = ref(true);
const emailNotFound = ref(false);
const serverErrorOccurred = ref(false);
const incorrectPassword = ref(false);
const lockedOut = ref(false);
const submitStatus = ref("");

const router = useRouter();

const rules = {
  userEmail: { required, email },
  password: { required, minLength: minLength(6) },
};

const state = {
  userEmail,
  password,
};

const v$ = useVuelidate(rules, state, { $autoDirty: true });

const isSubmitted = computed(() => submitStatus.value === "OK");

function removeErrorMessage(): void {
  incorrectPassword.value = false;
  emailNotFound.value = false;
  serverErrorOccurred.value = false;
  lockedOut.value = false;
}

function handleLogin(): void {
  const userLoginData = {
    email: userEmail.value.trim(),
    password: password.value.trim(),
    persistLogin: persistLogin.value,
  } as LoginApiModel;
  axios
    .post("/api/auth/login", userLoginData)
    .then((res) => {
      if (res.status === 200) {
        window.location.href = res.data ?? "/home";
      }
    })
    .catch((e: AxiosError) => {
      removeErrorMessage();
      debug(e);
      const statusCode = e.response?.status;
      submitStatus.value = "";
      if (statusCode === 401) {
        incorrectPassword.value = true;
      } else if (statusCode === 403) {
        lockedOut.value = true;
      } else if (statusCode === 404) {
        emailNotFound.value = true;
      } else if (statusCode === 500) {
        serverErrorOccurred.value = true;
      }
    });
}

function submitForm(): void {
  attemptedToSubmit.value = true;
  v$.value.$touch();
  if (v$.value.$invalid) {
    submitStatus.value = "Error";
  } else {
    submitStatus.value = "OK";
    handleLogin();
  }
}

onMounted(() => {
  const { query } = router.currentRoute.value;
  const source = query?.utm_source as string;
  if (source && typeof source === "string" && source.trim() !== "") {
    sessionStorage.setItem("utm_source", source);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("article", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("form", {
          class: "login-form",
          method: "post",
          onSubmit: _withModifiers(submitForm, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            (_unref(v$).userEmail.$error && _unref(v$).userEmail.email.$invalid && attemptedToSubmit.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Invalid email address "))
              : _createCommentVNode("", true),
            (_unref(v$).userEmail.$error && _unref(v$).userEmail.required.$invalid && attemptedToSubmit.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Required field "))
              : _createCommentVNode("", true),
            (emailNotFound.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Email address not found "))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              id: "email",
              "data-test": "email-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userEmail).value = $event)),
              class: "login-text-input",
              name: "email",
              placeholder: "Email",
              onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(v$).userEmail.$touch && _unref(v$).userEmail.$touch(...args))),
              onFocus: removeErrorMessage
            }, null, 544), [
              [
                _vModelText,
                userEmail.value,
                void 0,
                { trim: true }
              ]
            ]),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            (_unref(v$).password.$error && _unref(v$).password.required.$invalid && attemptedToSubmit.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Required field "))
              : _createCommentVNode("", true),
            (_unref(v$).password.$error && _unref(v$).password.minLength.$invalid && attemptedToSubmit.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Minimum 6 characters long "))
              : _createCommentVNode("", true),
            (incorrectPassword.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Incorrect password"))
              : _createCommentVNode("", true),
            (lockedOut.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                  _createTextVNode("Account is locked out due to too many failed attempts."),
                  _hoisted_20,
                  _createTextVNode("Please try again later.")
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              id: "password",
              "data-test": "password-input",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
              class: "login-text-input",
              placeholder: "Password",
              type: "password",
              onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(v$).password.$touch && _unref(v$).password.$touch(...args))),
              onFocus: removeErrorMessage
            }, null, 544), [
              [
                _vModelText,
                password.value,
                void 0,
                { trim: true }
              ]
            ]),
            _hoisted_21
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _withDirectives(_createElementVNode("input", {
                "data-test": "persist-checkbox",
                type: "checkbox",
                name: "checkbox",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((persistLogin).value = $event)),
                id: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, persistLogin.value]
              ]),
              _hoisted_24
            ])
          ]),
          (serverErrorOccurred.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Something went wrong, please try again later."))
            : _createCommentVNode("", true),
          _createVNode(SubmitButton, {
            "data-test": "submit-button",
            isSubmitted: isSubmitted.value,
            "use-recaptcha": false,
            disabled: false,
            buttonClass: "btn-primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Login ")
            ]),
            _: 1
          }, 8, ["isSubmitted"])
        ], 32),
        _hoisted_26
      ])
    ])
  ]))
}
}

})